import { Divider, Stack, Typography, TypographyProps } from "@mui/material";

export const TextualDivider = ({ children, ...restProps }: TypographyProps) => {
  return (
    <Stack
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      width="100%"
      my={5}
      gap={2}
    >
      <Divider sx={{ flex: 1 }} />
      <Typography variant="body1" fontSize={14} fontWeight={400} {...restProps}>
        {children}
      </Typography>
      <Divider sx={{ flex: 1 }} />
    </Stack>
  );
};
